import React, {useCallback, useEffect, useRef, useState} from "react"
import {useHistory} from "react-router-dom"
import {Button} from "devextreme-react/button"
import Form, {
    GroupItem,
    Item,
    Label,
    StringLengthRule,
    PatternRule,
    CompareRule,
    EmptyItem,
    ButtonItem,
    ButtonOptions, CustomRule
} from "devextreme-react/form"
import RadioGroup from 'devextreme-react/radio-group';
import './add-dogovor.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileLines, faKey, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
import Accordion, {Item as AccItem} from "devextreme-react/accordion";
import notify from "devextreme/ui/notify";
import {
    addFilesToOldReq, checkINN, clientSignRefused, isInnReadyForBackendCheck,
    daDataGet, deleteNewDogReq, delRequestAttach, getDepListDep, getDepListNet, getDogDocList,
    getDogKind, getDogovorToSigned, getDogovorZip, getDogovorZipAll,
    getFinalDogovor, getMessages, getOptionsRadio,
    getRequestAttach,
    getRequests, sendMessage, sendNewdogRequest, sendNewdogRequestUpdate
} from "../../api/newdog";
import LoadPanel from "devextreme-react/load-panel";
import ErrorPopup from "../../components/error-popup/error-popup";
import CustomStore from "devextreme/data/custom_store";
import {SelectBox} from "devextreme-react/select-box";
import {Buffer} from "buffer";
import {getddMMyyyyHHmm} from "../../utils/date.utils";
import {TextBox} from "devextreme-react";
import LoadIndicator from "devextreme-react/load-indicator";
import {formatTimestamp, isInnChecksumValid} from "../../utils/string.utils";
import {isAttachForDoc, isDocConditional, isDocMandatory, notAttachedDocs} from "../../utils/newdog-docs.utils";
import ExtFileUploader from "../../components/file-uploader/file-uploader";
import NewdogFiles from "../../components/newdog-files/newdog-files";
import PopSelectCert from "../../components/cryptopro/PopSelectCert";
import {useAuth} from "../../contexts/auth";
import {Popup} from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon"
import {getParamsFromResource} from "../../api/request";
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";
import {Validator as ValidatorDevex, RequiredRule as RequiredRuleValidator} from "devextreme-react/validator";
import Validator from 'devextreme/ui/validator';
import {Template} from "devextreme-react/core/template";
let formInstance

const normalizeApiList = (payload) => {
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload?.data)) return payload.data
    return []
}

const isFormValid = (ref) => {
    const result = ref.current?.instance?.validate?.()
    if (!result) return true
    return result.isValid
}

const AddDogovorTatenergosbytPage = () => {

    //region dogovor
    let formRef = [useRef(null), useRef(null), useRef(null), useRef(null)]

    const [triangle, setTriangle] = useState(false)
    const autocompleteRef = useRef({})

    const accordionRef = useRef(null);
    //const inputAddressRef = useRef(null);

    const [sourceOfFundingDisable, setSourceOfFundingDisable] = useState(true)
    const [selectedTypeDogovor, setSelectedTypeDogovor] = useState()
    //const [selectedConsumerType, setSelectedConsumerType] = useState(null)
    const [disabledForms, setDisabledForms] = useState(false)
    const [validateRequired, setValidateRequired] = useState(false)

    const [newdogFiles, setNewdogFiles] = useState(new Map())
    const [notDownloadsAndPreparedState, setNotDownloadsAndPreparedState] = useState(["0"])
    // const {newdogFiles, defaultType} = useReqPopup()
    // const [fileTypes, setFileTypes] =useState([])
    const [loading, setLoading] = useState(false)
    const [messageLoading, setMessageLoading] = useState('Сохраняем...')
    const [reqs, setReqs] = useState([])
    const [selectedReq, setSelectedReq] = useState({})
    const [dogKind, setDogKind] = useState([])
    const [depListDep, setDepListDep] = useState([])
    const [depListNet, setDepListNet] = useState([])
    const [optionsRadio, setOptionsRadio] = useState([])
    const [optionsRadioOnOff, setOptionsRadioOnOff] = useState(false)
    const [dogDocList, setDogDocList] = useState([])

    const [popupErrorVisible, setPopupErrorVisible] = useState(false);
    const [popupErrorText, setPopupErrorText] = useState('');
    const [popupIcon, setPopupIcon] = useState(null);
    const [popupTitle, setPopupTitle] = useState("Ошибка");
    const [popupWidth, setPopupWidth] = useState(500);
    const [popupClassNameColorIcon, setPopupClassNameColorIcon] = useState(null);
    const [onOk, setOnOk] = useState(null);
    const [popupYesNo, setPopupYesNo] = useState(false);
    const onCancel= () => {
        setPopupErrorVisible(false);
        setPopupYesNo(false);
        if (leavePromptRef.current) {
            leavePromptRef.current = false
            pendingNavRef.current = null
        }
        setPopupTextOk(null)
        setPopupTextCancel(null)
    };
    const onCancelWithOk = () => {setPopupErrorVisible(false); setPopupYesNo(false)};
    const [btnVisibleCancel, setBtnVisibleCancel] = useState(false);
    const [didLoad, setDidLoad] = useState(false);
    const [draftDirty, setDraftDirty] = useState(false)
    const [needsFirstSave, setNeedsFirstSave] = useState(false)
    const draftDirtyRef = useRef(false)
    const suppressDirtyRef = useRef(false)
    const savedSnapshotRef = useRef({})
    const allowLeaveRef = useRef(false)
    const unblockRef = useRef(null)
    const pendingNavRef = useRef(null)
    const leavePromptRef = useRef(false)
    const openLeavePromptRef = useRef(() => {})
    const history = useHistory()
    const [popupTextOk, setPopupTextOk] = useState(null)
    const [popupTextCancel, setPopupTextCancel] = useState(null)
    const [policyUrl, setPoilicyUrl] = useState('')
    //endregion

    // Преписка по заявке
    const [loadingMessage, setLoadingMessage] = useState(false)
    const [messages, setMessages] = useState([])
    const [visibleAddOldFiles, setVisibleAddOldFiles] = useState(false)
    const [finalDog, setFinalDog] = useState([])
    const { user, selectedDog } = useAuth()
    const messageFormData = useRef({})
    const formMessageRef = useRef()
    const extFileUploaderRef = useRef();
    const extFileUploaderPerepiskaRef = useRef();
    const [popupFindInnVisible, setPopupFindInnVisible] = useState(false)
    const [popupRefusedVisible, setPopupRefusedVisible] = useState(false)
    const [refusedMessage, setRefusedMessage] = useState('')
    const [finalDogId, setFinalDogId] = useState(null)
    const [nameCompany, setNameCompany] = useState(null)
    const [kppList, setKppList] = useState([])
    const [kpp, setKpp] = useState(null)
    const [requiredKpp, setRequiredKpp] = useState(true)
    const validateRequiredRef = useRef(false)
    const setValidateRequiredFlag = (value) => {
        validateRequiredRef.current = !!value
        setValidateRequired(!!value)
    }
    const requiredWhenSubmitting = (e) => {
        if (!validateRequiredRef.current) return true
        const v = e?.value
        return !(v === undefined || v === null || v === '')
    }
    /*    const [loadingInn, setLoadingInn] = useState(false)
        const [checkedInn, setCheckedInn] = useState(null)
        const [labelCheckInn, setLabelCheckInn] = useState(null)
        */

    const onSendRequest = async (validate) => {
        if (validate) {
            setValidateRequiredFlag(true)
            setValidateRequired(true)
            setRequiredKpp(selectedReq.inn?.length === 10)
            const conditionalMissing = await validForms()
            if (!conditionalMissing) {
                return
            }
            // есть такая заявка ранее?
            const equalZayavka = []
            reqs.forEach(e => {
                if (![3,11,4,10].includes[e.id_status] && e.ackt_tehn_num && e.contr_date &&
                    e.dogovor_type !== 2 &&
                    e.ackt_tehn_num === selectedReq.ackt_tehn_num &&
                    e.contr_date === selectedReq.contr_date &&
                    e.id !== selectedReq.id) {
                    equalZayavka.push(e)
                }
            })
            if (equalZayavka.length > 0) {
                notify(`Вы подали заявку № ${equalZayavka[0].ackt_tehn_num} ранее`,'error',5000)
                return
            }
            if (conditionalMissing.length > 0) {
                setNotDownloadsAndPreparedState(conditionalMissing.map(e => e.id))
                showConfirmConditionalDocs(conditionalMissing, async () => {
                    setValidateRequired(false)
                    selectedReq.status = 1
                    const result = await saveRequest()
                    if (result?.isOk) {
                        draftDirtyRef.current = false
                        setDraftDirty(false)
                        setNeedsFirstSave(false)
                    }
                })
                return
            }
            setValidateRequiredFlag(false)
            setValidateRequired(false)
            selectedReq.status = 1
        } else {
            setValidateRequiredFlag(false)
            setValidateRequired(false)
            setRequiredKpp(false)
            selectedReq.status = 10
            const equalZayavka = []
            reqs.forEach(e => {
                if (e.ackt_tehn_num && e.contr_date && e.id_status === 10 &&
                    e.ackt_tehn_num === selectedReq.ackt_tehn_num &&
                    e.contr_date === selectedReq.contr_date &&
                    e.id !== selectedReq.id) {
                    equalZayavka.push(e)
                }
            })
            if (equalZayavka.length > 0) {
                await showNotifyDeleteEqualZayavka(equalZayavka)
                return
            }
        }
        const result = await saveRequest()
        if (result?.isOk) {
            draftDirtyRef.current = false
            setDraftDirty(false)
            setNeedsFirstSave(false)
            if (!validate) savedSnapshotRef.current = {...selectedReq}
        }
    }

    const saveRequest = async () => {
        const fd = new FormData()
        Object.entries(selectedReq).forEach(([key, value]) => {
            fd.append(key, value)
        })
        await addFiles(fd)
        try {
            setLoading(true)
            return await createOrUpdateDogovor(fd)
        } catch (e) {
            notify(e.message, 'error', 5000)
            return {isOk: false}
        } finally {
            setLoading(false)
        }
    }

    // const checkDoubleZayavka = async () =>{
    //
    // }

    const showNotifyDeleteEqualZayavka = async (arrEqualZayavka) =>{
        setPopupErrorText("У вас уже есть сохраненная заявка, перезаписать?")
        setPopupIcon(faTriangleExclamation)
        setPopupTitle('Сообщение')
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupErrorVisible(true)
        setBtnVisibleCancel(true)
        setPopupTextOk(null)
        setPopupTextCancel(null)
        setOnOk(() => async () => {
            /*arrEqualZayavka.forEach(async (e) => {
                await deleteDog(e.id)
            });*/
            await deleteDog(arrEqualZayavka[0].id)
            await getListZayavka()
            //setPopupErrorVisible(false)
        })
    }

    const showNotifyDeleteZayavka = async (id) =>{
        setPopupErrorText("Удалить черновик?")
        setPopupIcon(faTriangleExclamation)
        setPopupTitle('Внимание')
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupErrorVisible(true)
        setBtnVisibleCancel(true)
        setPopupTextOk(null)
        setPopupTextCancel(null)
        setOnOk(() => async () => {
            const result = await deleteNewDogReq(id)
            if (result.isOk) {
                notify(result.data.message, 'success', 3000)
                draftDirtyRef.current = false
                setDraftDirty(false)
                setNeedsFirstSave(false)
                await getListZayavka()
                if (accordionRef.current) {
                    const instance = accordionRef.current.instance;
                    // Устанавливаем пустой массив для закрытия всех элементов
                    instance.option('selectedItemKeys', []);
                    instance.expandItem(0)
                }
            } else {
                notify(result.message, 'error', 5000)
            }
            setPopupErrorVisible(false)
        })
    }

    const deleteDog = async(id) =>{
        await showNotifyDeleteZayavka(id)
    }

    const showNotify = async (text, title = 'Ошибка') =>{
        setPopupErrorText(text)
        setPopupIcon(faTriangleExclamation)
        setPopupTitle(title)
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupErrorVisible(true)
        setBtnVisibleCancel(false)
        setPopupTextOk(null)
        setPopupTextCancel(null)
        setOnOk(() => () => {
            setPopupErrorVisible(false)
        })
    }

    const showConfirmConditionalDocs = (docs, onYes) => {
        const docList = docs.map(doc => '<li>' + doc.nameType + '</li>').join('')
        setPopupErrorText(`Приложены не все обязательные документы:<ol>${docList}</ol>Продолжить?`)
        setPopupIcon(faTriangleExclamation)
        setPopupTitle('Внимание')
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(500)
        setPopupYesNo(true)
        setBtnVisibleCancel(true)
        setPopupTextOk(null)
        setPopupTextCancel(null)
        setPopupErrorVisible(true)
        setOnOk(() => async () => {
            setPopupErrorVisible(false)
            setPopupYesNo(false)
            await onYes()
        })
    }

    const isSameDraftValue = (prev, value) => {
        const empty = (v) => v == null || v === '' || v === false
        if (empty(prev) && empty(value)) return true
        return String(prev ?? '') === String(value ?? '')
    }

    const saveOneFieldOnBlurFocus = async (key, value) => {
        if (!suppressDirtyRef.current && Number(selectedReq?.id_status) === 10) {
            if (!isSameDraftValue(savedSnapshotRef.current?.[key], value)) {
                draftDirtyRef.current = true
                setDraftDirty(true)
            }
        }
        setValidateRequiredFlag(false)
        setValidateRequired(false)
        if (!value) return
        const fd = new FormData()
        fd.append("status","10")
        fd.append(key,value)
        fd.append('id',selectedReq.id)
        if (key === 'inn') {
            await validateINN(value)
        }
        //await addFiles(fd);
        try {
            //setLoading(true)
            await createOrUpdateDogovor(fd)
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            //setLoading(false)
        }
    }

    const addFiles = async (fd) => {
        //region прикрепляем все файлы к заявке
        if (newdogFiles.size > 0) {
            let docTypes = []
            for (let newDogFile of newdogFiles.keys()) {
                fd.append('document', newdogFiles.get(newDogFile).file)
                docTypes.push(newdogFiles.get(newDogFile).type_id)
            }
            fd.append('doc_types', docTypes)
            newdogFiles.clear();
        }
        //endregion
    }

    const createOrUpdateDogovor = async(fd) =>{
        let result;
        if (fd?.get('id')){
            // проверка на дубли
            // const check = await checkDoubleZayavka()
            // if (check) return
            // update заявки
            result = await sendNewdogRequestUpdate(fd)
            if (result.isOk) {
                // если в заявке есть файлы получаем новый selectedReq чтобы обновилась форма с файлами
                const fdnew = Object.fromEntries(fd)
                if (fdnew.document || +result.status === 1) {
                    await getListZayavka()
                }
                /*((fdnew.inn && fdnew.inn !== selectedReq.inn) && (fdnew.name_company !== selectedReq.name_company || fdnew.kpp !== selectedReq.kpp))) {
                    await getListZayavka()
                }*/
                Object.keys(fdnew).length > 3 && notify(result.message, 'success', 500)
                return result
            } else {
                notify(result.message, 'error', 5000)
                return result
            }
        } else {
            // создание заявки id=null только один раз
            result = await sendNewdogRequest(fd)
            if (result.isOk) {
                notify(result.message.message, 'success', 3000)
                await getListZayavka()
                return result
            } else {
                notify(result.message, 'error', 5000)
                return result
            }
        }
    }

    const getListZayavka = async () => {
        suppressDirtyRef.current = true
        setLoading(true)
        const res = await getRequests()
        if (res.isOk) {
            const requests = normalizeApiList(res.data)
            setReqs(requests)
            // проверяем заявку
            if (requests.length > 0 && !selectedReq?.id) {
                setSelectedReq(requests[0])
                savedSnapshotRef.current = {...requests[0]}
                setSelectedTypeDogovor(requests[0]?.dogovor_type?.toString())
                setDisabledForms(requests[0].id_status !== 10)
                setRequiredKpp(requests[0].inn?.length === 10)//длина inn
            } else if (requests.length > 0) {
                const obj = requests.find((e) => e.id === selectedReq.id)
                if (obj) {
                    setSelectedReq(obj);
                    savedSnapshotRef.current = {...obj}
                    setDisabledForms(obj.id_status !== 10)
                    setSelectedTypeDogovor(obj?.dogovor_type?.toString())
                    setRequiredKpp(obj?.inn?.length === 10) //длина inn
                } else {
                    setSelectedReq(requests[0]);
                    savedSnapshotRef.current = {...requests[0]}
                    setSelectedTypeDogovor(requests[0]?.dogovor_type?.toString())
                    setDisabledForms(requests[0].id_status !== 10)
                    setRequiredKpp(requests[0].inn?.length === 10) //длина inn
                }
            } else {
                savedSnapshotRef.current = {}
                setDisabledForms(true)
            }
        } else {
            notify(res.message,'error',10000)
        }
        setLoading(false)
        setTimeout(() => { suppressDirtyRef.current = false }, 400)
    }

    useEffect(() => {
        (async function(){
            if (process.env.REACT_APP_NAME_ENV === 'renergy') { window.location.href = '#/add-dogovor/ext' }
            if (!didLoad) {
                await getListZayavka()
                setDidLoad(true);
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[didLoad])
    useEffect(() => {
        (async function(){
            //типы заявок
            const resDogKind = await getDogKind()
            if (resDogKind.isOk) setDogKind(normalizeApiList(resDogKind.data))
            //названия филиалов
            const resDepListDep = await getDepListDep()
            if (resDepListDep.isOk) setDepListDep(normalizeApiList(resDepListDep.data))

            //названия эл сети'
            const resDepListNet = await getDepListNet()
            if (resDepListNet.isOk) setDepListNet(normalizeApiList(resDepListNet.data))

            //типы документов файлов
            // const resTypes = await getFileTypes()
            // if (resTypes.isOk) setFileTypes(resTypes.data)

            //список radio
            const resOptions = await getOptionsRadio()
            if (resOptions.isOk) {
                const radioOptions = normalizeApiList(resOptions.data)
                setOptionsRadio(radioOptions)
                setOptionsRadioOnOff(radioOptions.length > 0)
            } else {
                setOptionsRadio([])
                setOptionsRadioOnOff(false)
            }

            const resPolicy = await getParamsFromResource('POLICY_URL')
            if (resPolicy.isOk) setPoilicyUrl(resPolicy.data)
        })();
    },[])


    useEffect(() => {
        let cancelled = false
        ;(async () => {
            const urFiz = selectedReq.inn.length === 10 ? 1 : selectedReq.inn.length === 12 ? 2 : undefined
            //if (!urFiz) return;
            const resDocTypes = await getDogDocList({
                dogkind_id: selectedTypeDogovor ?? undefined,
                id_req_type: selectedTypeDogovor ?? undefined,
                consumer_type_id: urFiz,
            })
            if (cancelled) return
            if (resDocTypes.isOk) {
                setDogDocList(normalizeApiList(resDocTypes.data))
            } else {
                setDogDocList([])
            }
        })()
        return () => { cancelled = true }
    }, [selectedTypeDogovor, selectedReq.inn, selectedReq])

    /* eslint-disable */
    useEffect(() => {
        (async function(){
            await openAllItems();
        })();
    },[])
    /* eslint-enable */

    // Функция для открытия всех элементов аккордеона
    const openAllItems = async () => {
        if (accordionRef.current) {
            const instance = accordionRef.current.instance;
            // Устанавливаем все индексы как открытые
            formRef.forEach((e,index) => {
                instance.expandItem(index)
            });
        }
    };

    // Функция для закрытия всех элементов аккордеона
    /*const closeAllItems = async () => {
        if (accordionRef.current) {
            const instance = accordionRef.current.instance;
            // Устанавливаем пустой массив для закрытия всех элементов
            instance.option('selectedItemKeys', []);
            instance.expandItem(0)
        }
    };*/

    // сюда помещаем все очистки форм после отправки (например)
    /*function cleanData() {
        //setNewdogFiles([])
    }*/

    // валидация форм
    const validForms = async () => {

        // если optionsRadio массив пуст удаляем третью форму (доп инфо) из валидации
        if (!optionsRadioOnOff && formRef.length === 4) {
            formRef.splice(2,1)
        }

        // boolFormRef === undefined → все формы обнаружены
        let boolFormRef = formRef.find(e => {
            return !e.current
        })

        if (!boolFormRef) {

            // валидируем все формы
            let result = formRef.map(e => {
                return e.current.instance.validate()
            })

            boolFormRef = result.find(e => {
                return !e.isValid
            })

            let messageError = ''
            const dogTypeDocs = dogDocList.filter(e => +e.dogkindId === +selectedTypeDogovor || +e.dogkindId === 0)
            const attachedForCheck = [
                ...(selectedReq.attachments ?? []),
                ...Array.from(newdogFiles).map(e => e[1].type_id),
            ]
            const mandatoryMissing = notAttachedDocs(dogTypeDocs.filter(isDocMandatory), attachedForCheck)
            const conditionalMissing = notAttachedDocs(dogTypeDocs.filter(isDocConditional), attachedForCheck)
            setNotDownloadsAndPreparedState(mandatoryMissing.map(e => e.id))
            mandatoryMissing.forEach(doc => {
                messageError += '<li>Файл: ' + doc.nameType + ' обязателен</li>'
            })

            // [] — всё приложено; непустой — спросить подтверждение отправки
            if (!boolFormRef && messageError === '') {
                return conditionalMissing
            } else {
                conditionalMissing.forEach(doc => {
                    messageError += '<li>Файл: ' + doc.nameType + ' обязателен</li>'
                })
                /*if (!isInnChecksumValid(selectedReq.inn)){
                    messageError += '<li>ИНН не корректный</li>'
                }*/
                result.map(e => {
                    return e.brokenRules.map(rule => {
                        messageError += '<li>' + rule.message + '</li>'
                        return null
                    })
                })
                await showNotify(`<ol>${messageError}</ol>`)
                //console.log('Невалидные поля:' + result1.brokenRules.map(rule => rule.message).toString());
                return false
            }
        }
    }

    const sourceOfFundingOptions = {
        valueChangeEvent:"blur",
        autoResizeEnabled:true,
        minHeight:35,
        onValueChanged: (e) => {
            setSourceOfFundingDisable(e.value === null || e.value === '')
        }
    }

    const dateOptions = {
        displayFormat: 'dd.MM.yyyy',
        useMaskBehavior: true,
        openOnFieldClick: true,
    }

    const clientsStore = new CustomStore({
        key: 'fias_id',
        useDefaultSearch: true,
        load: (loadOptions) => {
            if (loadOptions.filter) {
                //console.log(loadOptions.filter)
                return daDataGet(loadOptions?.filter[0][2], 'address')
                    .then((data) => ({
                        data: data.data.suggestions,
                    }))
                    .catch(() => {
                        throw new Error('Data Loading Error');
                    });
            }
        },
    });

    /*const bankStore = new CustomStore({
        key: 'bic',
        useDefaultSearch: true,
        load: (loadOptions) => {
            if (loadOptions.filter) {
                //console.log(loadOptions.filter)
                return daDataGet(loadOptions?.filter[0][2], 'bank')
                    .then((data) => ({
                        data: data.data.suggestions,
                    }))
                    .catch(() => {
                        throw new Error('Data Loading Error');
                    });
            }
        },
    });

    const selectionChangedBank = async (e) => {
        // пишем
        e.selectedItem?.data?.bic && await saveOneFieldOnBlurFocus('bic', e.selectedItem?.data?.bic);
        e.selectedItem?.data?.correspondent_account && await saveOneFieldOnBlurFocus('cor_account', e.selectedItem?.data?.correspondent_account);
        // устанавливаем current
        await getListZayavka()
    }*/

    // address
    const selectionChanged = async (e) => {
        e.selectedItem?.data?.fias_id && await saveOneFieldOnBlurFocus('id_fias', e.selectedItem?.data?.fias_id);
    }



    // select договора
    const onChangeDogovor = async (e) => {
        const selected = reqs.find(item => item.id === e.value)
        if (selected) {
            setSelectedReq(selected)
            savedSnapshotRef.current = {...selected}
            draftDirtyRef.current = false
            setDraftDirty(false)
            setNeedsFirstSave(false)
            setDisabledForms(selected.id_status !== 10)
            setSelectedTypeDogovor(selected?.dogovor_type?.toString())
            await getFinalDogovorAndRefreshMessage(selected)
        } else {
            setSelectedReq({})
            setDisabledForms(false)
            setSelectedTypeDogovor(null)
        }
        setRefusedMessage('')
        messageFormData.current.attachments = []
        messageFormData.current.message = ''
        formMessageRef.current?.instance.getEditor('message').reset()
        extFileUploaderPerepiskaRef?.current?.clearAttachFiles();
    }

    const continuePendingNavigation = () => {
        const pending = pendingNavRef.current
        pendingNavRef.current = null
        leavePromptRef.current = false
        if (!pending) return
        if (pending.kind === 'new') {
            newDogovor()
            return
        }
        if (pending.kind === 'req') {
            setRequiredKpp(reqs.find(r => r.id === pending.value)?.inn?.length === 10)
            setValidateRequired(false)
            setValidateRequiredFlag(false)
            onChangeDogovor({value: pending.value})
            return
        }
        allowLeaveRef.current = true
        if (unblockRef.current) {
            unblockRef.current()
            unblockRef.current = null
        }
        const {location, action} = pending
        const path = `${location.pathname}${location.search || ''}${location.hash || ''}`
        window.setTimeout(() => {
            if (action === 'REPLACE') history.replace(path)
            else if (action === 'POP') history.goBack()
            else history.push(path)
            allowLeaveRef.current = false
        }, 0)
    }

    const openLeavePrompt = () => {
        leavePromptRef.current = true
        setPopupErrorText('Есть несохранённые изменения. Перед переходом в другой раздел необходимо сохранить черновик.')
        setPopupIcon(faTriangleExclamation)
        setPopupTitle('Внимание')
        setPopupClassNameColorIcon('main-color-light')
        setPopupWidth(520)
        setPopupYesNo(false)
        setBtnVisibleCancel(true)
        setPopupTextOk('Сохранить')
        setPopupTextCancel('Остаться')
        setPopupErrorVisible(true)
        setOnOk(() => async () => {
            setPopupErrorVisible(false)
            setPopupYesNo(false)
            setPopupTextOk(null)
            setPopupTextCancel(null)
            leavePromptRef.current = false
            selectedReq.status = 10
            const result = await saveRequest()
            if (result?.isOk) {
                draftDirtyRef.current = false
                setDraftDirty(false)
                setNeedsFirstSave(false)
                savedSnapshotRef.current = {...selectedReq}
                continuePendingNavigation()
            }
        })
    }
    openLeavePromptRef.current = openLeavePrompt

    useEffect(() => {
        const onBeforeUnload = (event) => {
            if (!draftDirtyRef.current) return
            event.preventDefault()
            event.returnValue = ''
        }
        window.addEventListener('beforeunload', onBeforeUnload)
        unblockRef.current = history.block((location, action) => {
            if (allowLeaveRef.current || !draftDirtyRef.current) return undefined
            pendingNavRef.current = {kind: 'nav', location, action}
            openLeavePromptRef.current()
            return false
        })
        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload)
            if (unblockRef.current) {
                unblockRef.current()
                unblockRef.current = null
            }
        }
    }, [history])

    const getFinalDogovorAndRefreshMessage = async (selected) => {
        //получаем финальный договор
        if (!selected?.id || selected.id_status === 10) return
        const resFinalDog = await getFinalDogovor(selected.id)
        if (resFinalDog.isOk) {
            setFinalDog(resFinalDog.data)
        }
        //обновим переписку
        setLoadingMessage(true)
        const resMessages = await getMessages(selected.id)
        if (resMessages.isOk) {
            setMessages(resMessages.data)
        } else notify(resMessages.message, 'error', 10000)
        setLoadingMessage(false)
    }

    const deleteAkt = async (e) => {
        e.preventDefault()
        const idAttach = e.target.id
        setLoading(true)
        const res = await delRequestAttach(idAttach)
        if (res.isOk) {
            notify(res.data.message, 'success', 500)
            await getListZayavka()
        } else notify(res.message, 'error',10000)
        setLoading(false)
    }

    const onSendMessage = async (e) => {
        e.preventDefault()
        const {message, attachments} = messageFormData.current
        //console.log('message',Новое_сообщение, Вложение)
        if (!message) return;
        setLoadingMessage(true)

        const formData = new FormData()
        formData.append('request',selectedReq.id)
        formData.append('message', message)
        if (attachments !== undefined) {
            for (let attach of Array.from(attachments)) {
                formData.append('file', attach)
            }
        }

        const res = await sendMessage(formData)
        if (res.isOk) {
            e.target.reset()
            messageFormData.current = {message: '', attachments: []}
            extFileUploaderPerepiskaRef?.current?.clearAttachFiles();
            getFinalDogovorAndRefreshMessage(selectedReq)
        } else notify(res.message,'error',10000)
        setLoadingMessage(false)
    }

    async function downloadZip(id){
        const resZip = await getDogovorZip(id)
        if (resZip.isOk) {
            let fileDownload = require('js-file-download')
            fileDownload(Buffer.from(resZip.data.zip), resZip.data.zipName)
        }
    }
    async function downloadZipAll(id){
        setLoading(true)
        try {
            const resZip = await getDogovorZipAll(id)
            if (resZip.isOk) {
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(resZip.data.zip), resZip.data.zipName)
            } else {
                notify(resZip.message, 'error', 5000);
            }
        } catch (e) {
            notify(e.message, 'error', 5000);
        } finally {
            setLoading(false)
        }
    }
    // просмотр фала в браузере
    const downloadAsFile = async (idFile)=>{
        const fileToSigned = await getDogovorToSigned(idFile)
        let blob
        if (fileToSigned.data.dogovor.signedFile){
            blob = new Blob([new Uint8Array(fileToSigned.data.dogovor.signedFile.data)], {type: "application/pdf"});
        } else {
            blob = new Blob([new Uint8Array(fileToSigned.data.dogovor.attachment.data)], {type: "application/pdf"});
        }
        const blobUrl = URL.createObjectURL(blob);
        // Открываем в новом окне
        const newWindow = window.open(blobUrl, '_blank');
        // Освобождаем память после загрузки
        if (newWindow) {
            newWindow.onload = () => {
                URL.revokeObjectURL(blobUrl);
            };
        }
    };

    const downloadAkt = async (idAttach, isShowInNewWindow) => {
        setLoading(true)
        const res = await getRequestAttach(idAttach)
        if (res.isOk) {
            if (!isShowInNewWindow) {
                const data = res.data.attachment
                const filename = res.data.filename
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(data), filename)
            } else {
                let blob = new Blob([new Uint8Array(res.data.attachment.data)], {type: "application/pdf"});
                const blobUrl = URL.createObjectURL(blob);
                // Открываем в новом окне
                const newWindow = window.open(blobUrl, '_blank');
                // Освобождаем память после загрузки
                if (newWindow) {
                    newWindow.onload = () => {
                        URL.revokeObjectURL(blobUrl);
                    };
                }
            }
        } else notify(res.message, 'error',10000)
        setLoading(false)
    }

    const onSuccessSign = async () => {
        //получаем финальный договор
        const resFinalDog = await getFinalDogovor(selectedReq.id)
        if (resFinalDog.isOk) {
            setFinalDog(resFinalDog.data)
            notify('Документ успешно подписан!', 'success', 5000)
        }
    }

    const addFileToOldreq = async (type, files) => {
        const fd = new FormData()
        const s_req = selectedReq
        let types = []
        for (let i=0; i<files.length; i++) {
            fd.append('document', files[i])
            types.push(type.id)
        }
        fd.append('types', types)
        fd.append('id_req', s_req.id)
        setLoading(true)
        const resAdd = await addFilesToOldReq(fd)
        if (resAdd.isOk) {
            //обновим список заявок
            await getListZayavka()
            await getFinalDogovorAndRefreshMessage(selectedReq)
            //notify(res.message, 'success', 5000)
        } else notify(resAdd.message, 'error', 5000)
        setLoading(false)
    }

    const renderField = (data) => {
        return (
            <TextBox value={data ? `${getddMMyyyyHHmm(data.date_create)} ${data.name_company} - (${data.status})` : ''}
                // defaultValue={data ? `${getddMMyyyyHHmm(data.date_create)} ${data.name_company} - (${data.status})` : ''}
            />
        );
    }

    /*const onValueChanged = (files,index,obj) => {
        let source = newdogFiles
        if (files.length > 0) {
            files.map(e => {
                if (!e.delfiles) {
                    source.set(index + '' + obj.id + e.name, {
                        id: newdogFiles.size + 1000000,
                        type_name: obj.nameType,
                        type_id: obj.id,
                        file_name: e.name,
                        file: e,
                        index: index
                    })
                } else {
                    source.delete(index + '' + obj.id + e.name)
                }
                return null;
            })
        }
        setNewdogFiles(source)
    }*/

    const saveFilesToDraft = async (filesMap) => {
        if (!selectedReq?.id || !filesMap?.size) return false
        const fd = new FormData()
        fd.append('status', '10')
        fd.append('id', selectedReq.id)
        const docTypes = []
        for (const entry of filesMap.values()) {
            fd.append('document', entry.file)
            docTypes.push(entry.type_id)
        }
        fd.append('doc_types', docTypes)
        try {
            setLoading(true)
            const result = await createOrUpdateDogovor(fd)
            return !(result && result.isOk === false)
        } catch (e) {
            notify(e.message, 'error', 5000)
            return false
        } finally {
            setLoading(false)
        }
    }

    const onValueChanged = async (files, index, obj) => {
        const toSave = new Map()
        if (files.length > 0) {
            files.forEach(e => {
                if (!e.delfiles) {
                    toSave.set(index + '' + obj.id + e.name, {
                        id: toSave.size + 1000000,
                        type_name: obj.nameType,
                        type_id: obj.id,
                        file_name: e.name,
                        file: e,
                        index: index
                    })
                }
            })
        }
        if (!toSave.size) return
        if (Number(selectedReq?.id_status) === 10) {
            draftDirtyRef.current = true
            setDraftDirty(true)
        }
        const ok = await saveFilesToDraft(toSave)
        if (!ok) {
            // оставляем в памяти — уйдут по «Сохранить черновик»
            setNewdogFiles(prev => {
                const next = new Map(prev)
                toSave.forEach((v, k) => next.set(k, v))
                return next
            })
        }
    }

    const newDogovor = async () => {
        const fd = new FormData()
        fd.append("status","10")
        fd.append('name_company','')
        if (!dogKind?.length) {
            notify('Список типов заявок ещё не загружен', 'error', 5000)
            return
        }
        fd.append('dogovor_type', dogKind[0].id)
        setSelectedTypeDogovor(String(dogKind[0].id))
        const innValue = user.inn || selectedDog?.inn || ''
        if (user.inn) {
            fd.append("inn",user.inn)
            selectedReq.inn = user.inn
            await validateINN(user.inn)
        } else if (selectedDog?.inn) {
            fd.append("inn",selectedDog.inn)
            selectedReq.inn = selectedDog.inn
            await validateINN(selectedDog.inn)
        }
        if (selectedDog?.kpp) {
            fd.append("kpp",selectedDog.kpp)
            selectedReq.kpp = selectedDog.kpp
        }
        setRequiredKpp(String(innValue).length === 10)
        selectedReq.attachments = []
        selectedReq.id = null
        const result = await createOrUpdateDogovor(fd)
        if (result?.isOk) {
            draftDirtyRef.current = true
            setDraftDirty(true)
            setNeedsFirstSave(true)
        }
        setValidateRequired(false)
        if (accordionRef.current) {
            const instance = accordionRef.current.instance;
            // Устанавливаем пустой массив для закрытия всех элементов
            instance.option('selectedItemKeys', []);
            instance.expandItem(0)
        }
    }

    //проверяем инн по апи и заполняем поля
    const validateINN = async (inn) => {
        const innStr = String(inn ?? '').trim()
        if (!isInnReadyForBackendCheck(innStr)) {
            return
        }

        try {
            setMessageLoading('Проверяем ИНН...')
            const res = await checkINN(innStr)
            if (!res.isOk) {
                //notify(res.message || 'Ошибка при проверке ИНН!', 'error', 5000)
                console.log(res.message || 'Ошибка при проверке ИНН!')
                return
            }
            if (res.localOnly) {
                return
            }
            const parsedData = await parseKonturRes(res.data)
            if (parsedData) {
                setNameCompany(parsedData.name)
                setKppList(parsedData.listKpp)
                setKpp(parsedData.listKpp[0])
                setPopupFindInnVisible(true)
            }
        } finally {
            setMessageLoading('Сохраняем...')
        }
    }

    async function parseKonturRes(json) {
        if (json.length === 0) return null
        const companyUl = json[0].UL
        const nameCompany = companyUl.legalName.full
        const branches = companyUl.branches
        let listKpp = [companyUl.kpp]
        if (branches) {
            for (let i = 0; i < branches.length; i++) {
                listKpp.push(branches[i].kpp)
            }
        }
        return {name: nameCompany, listKpp: listKpp}
        //return {name: 'Название компании из ИНН', listKpp: ['123456789','987654321']}
    }



    const changeKPP = useCallback((e) => {
            setKpp(e.value);
        },[setKpp],
    );

    const hidePop = () => {
        setPopupFindInnVisible(false)
    }

    const hidePopRefused = () => {
        setRefusedMessage('')
        setPopupRefusedVisible(false)
    }

    const onFormSubmitRefused = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const res = await clientSignRefused(selectedReq.id, finalDogId, refusedMessage)
            if (res.isOk) {
                await getFinalDogovorAndRefreshMessage(selectedReq)
                setRefusedMessage(null)
                notify(res.message, 'success', 5000)
            } else {
                notify(res.message, 'error', 5000)
            }
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setLoading(false)
            hidePopRefused();
        }

    }

    const onInitialized = (e) => {
        formInstance = e.component;
    }

// Кастомный компонент textarea
//     const textAreaInput = (data) => {
//         return (
//             <div>
//                 <TextArea
//                     defaultValue={data ? `${data.adress}` : ''}
//                 />
//             </div>
//         );
//     };

    const isDraft = Number(selectedReq?.id_status) === 10 && !!selectedReq?.id

    return (
        <div className={'content-block dx-card responsive-paddings'}>
            <>
                <LoadPanel message={messageLoading} visible={loading} />
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines} />
                <h3><strong><ZagolovokFromMenu/></strong></h3>
                <SelectBox labelMode={'outside'}
                           label={'Мои заявки'} className="big-input mt-4"
                           noDataText="Нет заявок для отображения"
                           placeholder="Выберите заявку.."
                           dataSource={reqs}
                           displayExpr="name_company"
                           valueExpr="id"
                           value={selectedReq ? selectedReq.id : null}
                    //defaultValue={selectedReq[0].id}
                           onValueChanged={(e) => {
                               if (!e.event) return
                               if (draftDirtyRef.current && String(e.value) !== String(selectedReq?.id ?? '')) {
                                   pendingNavRef.current = {kind: 'req', value: e.value}
                                   e.component?.option('value', selectedReq?.id ?? null)
                                   openLeavePromptRef.current()
                                   return
                               }
                               setRequiredKpp(reqs.find(r => r.id === e.value)?.inn?.length === 10)
                               setValidateRequired(false)
                               setValidateRequiredFlag(false)
                               onChangeDogovor(e);
                           }}
                           searchEnabled={true}
                           itemRender={(e) => <div><span className='small'>{getddMMyyyyHHmm(e.date_create)}</span> {e.name_company} - ({e.status})</div>}
                           fieldRender={renderField}

                >
                </SelectBox>
                <div className={'mt-3'}>Информация, обозначенная символом * является обязательной для заполнения</div>
                <Accordion
                    ref={accordionRef}
                    className={'mt-2 add-dogovor-tat'}
                    animationDuration={300}
                    id="accordion-container"
                    multiple={true}
                    collapsible={true}
                    triangle={triangle}
                >
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{ fontSize: '16px', color: 'red',marginRight: '10px', display: isFormValid(formRef[0]) ? 'none':'inline'}} className="dx-icon-warning"></i>
                            <span>Общие сведения</span>
                        </div>
                    )}>
                        <form className="" >
                            <Form
                                disabled={disabledForms}
                                ref={formRef[0]}
                                formData={selectedReq}
                                id="dogovor-form1"
                                colCount={2}
                                labelMode= "floating"
                                labelLocation="left"
                                onFieldDataChanged={ (e) => {
                                    setTriangle(isFormValid(formRef[0]));
                                    saveOneFieldOnBlurFocus(e.dataField, e.value)
                                }
                                }
                                onInitialized={onInitialized}
                            >


                                <GroupItem>
                                    <GroupItem colCount={selectedReq.num_req ? 2:1} cssClass={'mt-0'}>
                                        <GroupItem>
                                            <Item editorType={'dxSelectBox'} dataField={'dogovor_type'} isRequired={true} editorOptions={{
                                                noDataText: "Нет заявок для отображения",
                                                placeholder: "Тип заявки",
                                                dataSource: dogKind,
                                                displayExpr: "name",
                                                valueExpr: "id",
                                                defaultValue: selectedTypeDogovor,
                                                value: selectedTypeDogovor,
                                                onValueChanged: function(e) {
                                                    e.value && setSelectedTypeDogovor(e.value.toString())
                                                }

                                            }} >
                                                <Label text={'Тип заявки'} />
                                                <CustomRule message="Тип заявки обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                            </Item>
                                        </GroupItem>
                                        <GroupItem visible={!!selectedReq.num_req}>
                                            <Item dataField="num_req" editorType="dxTextBox" disabled={true}>
                                                <Label text={"Номер заявки"}/>
                                            </Item>
                                        </GroupItem>
                                    </GroupItem>
                                    <GroupItem>
                                        <Item dataField="name_company" isRequired={true}
                                              editorType="dxTextArea" editorOptions={{
                                                  valueChangeEvent:"keyup",
                                            autoResizeEnabled:true,
                                            minHeight:35,
                                            hint:'Наименование организации, ИП, ФЛ осуществляющее коммерческую деятельность'}}>
                                            <Label text={"Наименование организации, ИП, ФЛ осуществляющее коммерческую деятельность"}/>
                                            <StringLengthRule max={500} message="Наименование максимум 500 символов" />
                                            <PatternRule
                                                pattern=".{3,500}"
                                                message="Наименование организации минимум 3 символа"
                                            />
                                            <CustomRule message="Наименование организации, ИП, ФЛ осуществляющее коммерческую деятельность" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                        </Item>
                                    </GroupItem>
                                    <GroupItem colCount={2}>
                                        <Item dataField="inn" isRequired={true} editorType="dxTextBox" editorOptions={{
                                            inputAttr: { maxLength: 12, pattern: '\\d*' }, // Ограничение длины ввода до 20 символов
                                            format: '#',
                                            valueChangeEvent:"keyup",
                                            onInput: (e) => {
                                                // Оставляем только цифры в поле ввода
                                                const val = e.event.target.value.replace(/\D/g, '').slice(0,12);
                                                e.event.target.value = val;
                                                const editor = formInstance?.getEditor('inn');
                                                if (editor) {
                                                    const instance = Validator.getInstance(editor.element());
                                                    const length = val?.toString().length
                                                    instance.isValid = (length !== 10 && length !== 12) && isInnChecksumValid(val);
                                                    setRequiredKpp(length === 10)
                                                    editor.element().focus();
                                                }
                                            }
                                        }}>
                                            <Label text={"ИНН"} />
                                            {validateRequired && <CustomRule
                                                message="Неверная контрольная сумма ИНН."
                                                validationCallback={(e) => {
                                                    return isInnChecksumValid(e.value);
                                                }}
                                                reevaluate={true}
                                            />
                                            }
                                            <CustomRule message="Поле ИНН обязательно. 10 или 12 цифр" validationCallback={requiredWhenSubmitting} reevaluate={true} />
                                            <PatternRule pattern="^\d{10}(\d{2})?$" message="Поле ИНН 10 или 12 цифр!" />
                                        </Item>
                                        {/*{!checkedInn ?*/}
                                        <Item dataField="kpp" isRequired={selectedReq.inn?.length === 10} editorType="dxTextBox" editorOptions={{
                                            inputAttr: { maxLength: 9, pattern: '\\d*' }, // Ограничение длины ввода до 9 символов
                                            format: '#',
                                            valueChangeEvent:"keyup",
                                            onInput: (e) => {
                                                // Оставляем только цифры в поле ввода
                                                e.event.target.value = e.event.target.value.replace(/\D/g, '').slice(0,9);
                                                const editor = formInstance?.getEditor('kpp');
                                                if (editor) {
                                                    const instance = Validator.getInstance(editor.element());
                                                    //const length = e.event.target.value?.toString().length;
                                                    if (instance) {
                                                        instance.isValid = (selectedReq.inn?.length === 10)
                                                        instance.validate();
                                                    }
                                                    editor.element().focus();
                                                }
                                            }
                                        }}>
                                            <Label text={"КПП"} />
                                            {requiredKpp &&
                                                <CustomRule message="Поле КПП обязательно! 9 цифр" validationCallback={requiredWhenSubmitting} reevaluate={true}/>
                                            }
                                            {requiredKpp && validateRequired &&
                                                <PatternRule pattern="^\d{9}$" message="Поле КПП 9 цифр!" />
                                            }
                                            {requiredKpp && !validateRequired &&
                                                <PatternRule pattern="^\d{9}$" message="Поле КПП 9 цифр!" />
                                            }

                                            {!requiredKpp &&
                                                <PatternRule pattern="^\d{0}(\d{9})?$" message="Поле КПП пусто или 9 цифр!" />
                                            }
                                        </Item>
                                    </GroupItem>
                                    <GroupItem>
                                        <Item
                                            dataField="adress" isRequired={true}
                                            editorType="dxAutocomplete"
                                            editorOptions={{
                                                showClearButton: true,
                                                dataSource: clientsStore,
                                                valueExpr: "unrestricted_value",
                                                placeholder: "Начните вводить адрес...",
                                                minSearchLength: 1,
                                                searchTimeout: 300,
                                                ref: autocompleteRef,
                                                valueChangeEvent:"blur",
                                                onSelectionChanged: selectionChanged,
                                                validationMessagePosition:"top",
                                                hint:'Адрес объекта энергоснабжения/энергопринимающего устройства'
                                            }}
                                        >
                                            <Label text="Адрес объекта энергоснабжения/энергопринимающего устройства" />
                                            <CustomRule message="Адрес обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true}/>
                                        </Item>
                                    </GroupItem>
                                </GroupItem>
                                <GroupItem>
                                    {['tatenergosbyt','renergy'].includes(process.env.REACT_APP_NAME_ENV) &&
                                        <GroupItem>
                                            <Item dataField="electrical_net" isRequired={true} editorType="dxSelectBox" editorOptions={{
                                                dataSource:depListNet,
                                                displayExpr:"name",
                                                valueExpr:"kodp",
                                                itemTemplate: "myItemTemplate",
                                                validationMessagePosition:"top",
                                            }}>
                                                <Label text={"Филиал Cетевой компании"}/>
                                                <CustomRule message="Филиал Cетевой компани обязателен" validationCallback={requiredWhenSubmitting} reevaluate={true}/>
                                                <Template name='myItemTemplate' render={(itemData) => {
                                                    return (<div style={itemData.level === 0 ? {} : itemData.level === 1 ? {marginLeft: '20px'}:{marginLeft: '40px'}}>{itemData.name}</div>)}} />
                                            </Item>
                                        </GroupItem>
                                    }
                                    {selectedTypeDogovor !== "5" &&
                                        <GroupItem>
                                            {!['tatenergosbyt','renergy'].includes(process.env.REACT_APP_NAME_ENV) &&
                                                <Item dataField="electrical_net" editorType="dxSelectBox" editorOptions={{
                                                    dataSource:depListNet,
                                                    displayExpr:"name",
                                                    valueExpr:"kodp"}} >
                                                    <Label text={"Наименование эл.сетей"}/>
                                                </Item>
                                            }
                                            <GroupItem colCount={2}>
                                                <Item dataField="ackt_tehn_num" editorType="dxTextBox" editorOptions={{hint:'Номер договора на технологическое присоединение'}}>
                                                    <Label text={"Номер договора на технологическое присоединение"}/>
                                                </Item>
                                                <Item dataField="contr_date" editorType="dxDateBox" editorOptions={{...dateOptions, hint:'Дата договора на технологическое присоединение'}}>
                                                    <Label text={"Дата договора на технологическое присоединение"}/>
                                                </Item>
                                            </GroupItem>
                                            <GroupItem colCount={2}>
                                                <Item dataField="phone" editorOptions={{mask: '+7 (YX0) 000-0000', maskRules: { X: /[01-9]/, Y: /[9]/ } }} editorType="dxTextBox">
                                                    <Label text={"Телефон заявителя"}/>
                                                </Item>
                                            </GroupItem>
                                        </GroupItem>
                                    }
                                    {selectedTypeDogovor === "5" &&
                                        <GroupItem>
                                            <Item dataField="fin_src" editorType="dxTextArea" editorOptions={sourceOfFundingOptions}>
                                                <Label text={"Источник финансирования"}/>
                                            </Item>
                                            <GroupItem>
                                                <Item dataField="contr_price" editorType="dxTextBox" editorOptions={{
                                                    disabled: sourceOfFundingDisable,
                                                    inputAttr: { maxLength: 20, pattern: '\\d*' }, // Ограничение длины ввода до 20 символов
                                                    format: '#',
                                                    onInput: (e) => {
                                                        // Оставляем только цифры в поле ввода
                                                        e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                                    },
                                                }}
                                                >
                                                    <Label text={"Цена контракта (договора)"} />
                                                    <StringLengthRule max={20} message={`Цена контракта должна содержать до 20 цифр`} />
                                                </Item>
                                            </GroupItem>
                                            <GroupItem colCount={2}>
                                                <Item dataField="contr_begin" editorType="dxDateBox" editorOptions={{...dateOptions, disabled: sourceOfFundingDisable}}>
                                                    <Label text={"Срок действия контракта с"}/>
                                                </Item>
                                                <Item dataField="contr_end" editorType="dxDateBox" editorOptions={{...dateOptions, disabled: sourceOfFundingDisable}}>
                                                    <Label text={"Срок действия контракта по"}/>
                                                </Item>
                                            </GroupItem>
                                        </GroupItem>
                                    }
                                    <GroupItem>
                                        <Item dataField="branch" editorType="dxSelectBox" editorOptions={{
                                            dataSource:depListDep,
                                            displayExpr:"name",
                                            valueExpr:"kodp"}}>
                                            <Label text={"Наименование филиала"}/>
                                        </Item>
                                    </GroupItem>
                                </GroupItem>
                            </Form>
                        </form>
                    </AccItem>
                    {/*<AccItem titleRender={() => (
                        <div>
                            <i style={{ fontSize: '16px', color: 'red',marginRight: '10px', display: isFormValid(formRef[1]) ? 'none':'inline'}} className="dx-icon-warning"></i>
                            <span>Банковские реквизиты</span>
                        </div>
                    )}>
                        <form className="">
                            <Form disabled={disabledForms}
                                  ref={formRef[1]}
                                  formData={selectedReq}
                                  id="dogovor-form2"
                                  colCount={2}
                                  labelMode= "floating"
                                  labelLocation="left"
                                  onFieldDataChanged={ (e) => {
                                      setTriangle(isFormValid(formRef[1]));
                                      saveOneFieldOnBlurFocus(e.dataField, e.value)
                                      console.log('save - ' + e.dataField + ': ' + e.value)
                                  }
                                  }

                            >
                                <GroupItem colCount={2} colSpan={2}>
                                    <Item
                                        dataField="bank"
                                        editorType="dxAutocomplete"
                                        editorOptions={{
                                            showClearButton: true,
                                            dataSource: bankStore,
                                            valueExpr: "unrestricted_value",
                                            placeholder: "Начните вводить название банка или бик...",
                                            minSearchLength: 1,
                                            searchTimeout: 300,
                                            valueChangeEvent:"blur",
                                            onSelectionChanged: selectionChangedBank
                                        }}
                                    >
                                        <Label text="Банк" />
                                        {validateRequired &&
                                            <RequiredRule message="Банк обязателен" />
                                        }

                                    </Item>
                                    <Item dataField="bic" editorType="dxTextBox" editorOptions={
                                        {
                                            valueChangeEvent:"keyup",
                                            inputAttr: { maxLength: 9, pattern: '\\d*' },
                                            format: '#',
                                            onInput: (e) => {
                                                // Оставляем только цифры в поле ввода
                                                e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                            },
                                        }
                                    }>

                                        <Label text={"БИК"} />
                                        {validateRequired &&
                                            <RequiredRule message="БИК обязателен" />
                                        }
                                        <StringLengthRule max={9} message="Бик должен содержать ровно 9 цифр" />
                                        <PatternRule pattern="^\d{9}$" message="БИК должен содержать ровно 9 цифр" />
                                    </Item>

                                    <Item dataField="pay_account" editorType="dxTextBox" editorOptions={{
                                        inputAttr: { maxLength: 20, pattern: '\\d*' },// Ограничение длины ввода до 20 символов
                                        validationMessagePosition:"top",
                                        valueChangeEvent:"keyup",
                                        format: '#',
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                    }}
                                    >
                                        <Label text={"Расчетный счет"} />
                                        {validateRequired &&
                                            <RequiredRule message="Расчетный счет обязателен" />
                                        }
                                        <StringLengthRule max={20} message={`Расчетный счет должен содержать ровно 20 цифр`} />
                                        <PatternRule pattern="^\d{20}$" message="Расчетный счет должен содержать ровно 20 цифр" />
                                    </Item>

                                    <Item dataField="cor_account" editorType="dxTextBox" editorOptions={{
                                        inputAttr: { maxLength: 20, pattern: '\\d*' }, // Ограничение длины ввода до 20 символов
                                        format: '#',
                                        valueChangeEvent:"keyup",
                                        onInput: (e) => {
                                            // Оставляем только цифры в поле ввода
                                            e.event.target.value = e.event.target.value.replace(/\D/g, '');
                                        },
                                        validationMessagePosition:"top",
                                    }}>
                                        <Label text={"Корр.счет"} />
                                        {validateRequired &&
                                            <RequiredRule message="Корр.счет обязателен" />
                                        }
                                        <StringLengthRule max={20} message="Корр.счет должен содержать ровно 20 цифр" />
                                        <PatternRule pattern="^\d{20}$" message="Корр.счет должен содержать ровно 20 цифр" />
                                    </Item>
                                </GroupItem>
                                {selectedTypeDogovor === "5" &&
                                    <GroupItem colCount={2} colSpan={2}>
                                        <Item dataField="treasury" editorType="dxTextBox">
                                            <Label text={"Казначейство"} />
                                            <StringLengthRule max={1000} message="Максимальная длина - 1000 символов" />
                                        </Item>

                                        <Item dataField="per_account" editorType="dxTextBox" >
                                            <Label text={"№ лицевого счета"} />
                                            <StringLengthRule max={50} message="Максимальная длина - 50 символов" />
                                        </Item>
                                    </GroupItem>
                                }
                            </Form>
                        </form>
                    </AccItem>*/}
                    <AccItem titleRender={() => (
                        <div>
                            <i style={{ fontSize: '16px', color: 'red',marginRight: '10px',
                                display: (validateRequired && notDownloadsAndPreparedState.length > 0) ? 'inline':'none'}} className="dx-icon-warning"></i>
                            <span>Документы к заявке</span>
                        </div>
                    )}>
                        <Form
                            ref={formRef[1]}
                            id="dogovor-form3"
                            colCount={1}
                            labelMode= "hidden"
                            className='popupWithUploader'
                        >
                            {
                                selectedReq &&
                                ![10].includes(selectedReq.id_status) &&
                                <GroupItem>
                                    <Item>
                                        <ol className='round-button-only-icon'>
                                            {
                                                selectedReq?.attachments?.map(file =>
                                                    <li className='mb-1' key={file.id}>
                                                        <Button className='mr-3' hint='Скачать' type='default' icon='download' onClick={ async () => await downloadAkt(file.id, false)}></Button>
                                                        {/*<Button className='mr-1' icon='eyeopen' hint='Открыть в новой вкладке' type='default' onClick={ async () => downloadAkt(file.id, true)}></Button>{file.name_type}:
                                                        {file.filename}*/}
                                                        {file.name_type}: <a className="dashed" id="link1" href='/' onClick={async (e) => {e.preventDefault(); await downloadAkt(file.id, true); }}>{file.filename}</a>
                                                    </li>)
                                            }
                                        </ol>
                                        <Button className="" text="Добавить документы" icon="add" onClick={()=>{setVisibleAddOldFiles(true)}}/>
                                        {/*maxLengthFileName - сработает только для ТЭС*/}
                                        <NewdogFiles typeFileLimit={'newdog'} maxLengthFileName={124} visible={visibleAddOldFiles} types={dogDocList} onClose={() => setVisibleAddOldFiles(false)} onAddFiles={addFileToOldreq}/>
                                    </Item>
                                </GroupItem>
                            }
                            {
                                selectedReq?.id_status === 10 &&
                                dogDocList &&
                                [...dogDocList].sort((a,b) => +a.fillOrder - +b.fillOrder)
                                    .map((obj,index) => {
                                const rowKey = String(obj.id)
                                const slotAttaches = (selectedReq?.attachments ?? []).filter(e => isAttachForDoc(e, obj))
                                return (
                                        <GroupItem key={rowKey}>
                                            <Item isRequired={true}>
                                                <div className={'row'}>
                                                    <div className='col-md-6 mb-3'>
                                                        <i style={{ fontSize: '16px', color: 'red',marginRight: '10px',
                                                            display: (validateRequired && notDownloadsAndPreparedState.length > 0 && +obj.needUse !== 10 && notDownloadsAndPreparedState.includes(obj.id)) ? 'inline':'none'}} className="dx-icon-warning"></i>
                                                        <span className={'nameType mb-1'}>{(isDocMandatory(obj) || isDocConditional(obj)) && <span title={'Обязательный документ'} className={'text-danger'}>✱</span>} {index+1}. {obj.nameType}</span><br/>
                                                        <small>{obj.info}</small><br/>
                                                        <ul>
                                                            {(selectedReq?.attachments ?? []).filter(e => isAttachForDoc(e, obj)).map((e) =>
                                                                <li key={e.id}><a href={'/'} onClick={async (ev) => { ev.preventDefault(); await downloadAkt(e.id, false) }} id={e.id}>{e.filename}</a>
                                                                    &nbsp;&nbsp;—&nbsp;&nbsp;
                                                                    <a href={'/'} onClick={deleteAkt} id={e.id}>Удалить</a><br/></li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        {/*maxLengthFileName - сработает только для ТЭС*/}
                                                        <ExtFileUploader
                                                            key={`${selectedReq.id}-${rowKey}-${slotAttaches.length}`}
                                                            maxLengthFileName={120}
                                                            selectedReqId={selectedReq.id ?? null}
                                                            disabledForms={disabledForms}
                                                            typeFileLimit={'newdog'} ref={extFileUploaderRef}
                                                            setfile={(e) => onValueChanged(e,index,obj) }></ExtFileUploader>
                                                    </div>
                                                </div>
                                                <hr/>
                                            </Item>
                                        </GroupItem>
                                )
                                    })
                            }
                        </Form>
                    </AccItem>
                    {/* Если optionsRadio пуст скрывем этот AccItem*/}
                    <AccItem visible={optionsRadioOnOff} titleRender={() => (
                        <div>
                            <i style={{
                                fontSize: '16px',
                                color: 'red',
                                marginRight: '10px',
                                display: isFormValid(formRef[2]) ? 'none' : 'inline'
                            }} className="dx-icon-warning"></i>
                            <span>Дополнительная информация</span>
                        </div>
                    )}>
                        <form className="">
                            <Form
                                disabled={disabledForms}
                                ref={formRef[2]}
                                formData={selectedReq}
                                id="dogovor-form4"
                                colCount={2}
                                labelMode="floating"
                                labelLocation="top"
                                onFieldDataChanged={(e) => {
                                    setTriangle(isFormValid(formRef[2]))
                                    saveOneFieldOnBlurFocus(e.dataField, e.value)
                                }
                                }
                            >

                                {
                                    optionsRadio?.map((e) => {
                                        return <Item key={e.field_name}
                                                     dataField={e.field_name}
                                                     editorType="dxRadioGroup"
                                                     isRequired={true}
                                                     editorOptions={{
                                                         items: e.items,
                                                         defaultValue: null,
                                                         displayExpr: 'name',
                                                         valueExpr: 'val',
                                                     }}
                                        >
                                            <Label text={e.opt_name}/>
                                            <CustomRule message={`${e.opt_name} - обязательно`} validationCallback={requiredWhenSubmitting} reevaluate={true}/>
                                        </Item>
                                    })
                                }
                            </Form>
                        </form>
                    </AccItem>
                </Accordion>
                <div className='agreement-row mt-4'>
                <form  className="agreement-wrapper">
                    <Form
                        className="mt-4"
                        visible={!disabledForms}
                        ref={formRef[3]}
                        formData={selectedReq}
                        id="dogovor-form5"
                        colCount={1}
                        labelMode= "floating"
                        labelLocation="left"
                        onFieldDataChanged={(e) => {
                            if (suppressDirtyRef.current || Number(selectedReq?.id_status) !== 10) return
                            if (!isSameDraftValue(savedSnapshotRef.current?.[e.dataField], e.value)) {
                                draftDirtyRef.current = true
                                setDraftDirty(true)
                            }
                        }}
                    >
                        <Item dataField="accepted"
                              editorType="dxCheckBox">
                            <Label visible={false} />
                            <CompareRule message="Необходимо принять условия обработки данных"
                                         comparisonTarget={() => true}
                            />
                        </Item>
                    </Form>
                </form>
                {!disabledForms &&
                    <span className='check-box-tatenergo'>Принимаю <a href={policyUrl} target="_blank" rel="noopener noreferrer">условия обработки данных</a></span>
                }
                </div>
                <div className='row mb-5'>
                    <div className='col-sm-6 col-md-6 col-lg-3'><Button className="mt-4 block" icon="plus" disabled={isDraft && needsFirstSave} type={'default'} text="Новая заявка" hint="Новая заявка" onClick={() => {
                        if (draftDirtyRef.current) {
                            pendingNavRef.current = {kind: 'new'}
                            openLeavePromptRef.current()
                            return
                        }
                        newDogovor()
                    }}/></div>
                    <div className='col-sm-6 col-md-6 col-lg-3'><Button className="mt-4 block" icon="edit" disabled={!isDraft || !draftDirty} type={'default'} text="Сохранить черновик" hint="Сохранить черновик" onClick={() => onSendRequest(false)}/></div>
                    <div className='col-sm-6 col-md-6 col-lg-3'><Button className="mt-4 block" icon="trash" disabled={!isDraft} type={'default'} text="Удалить черновик" hint="Удалить черновик" onClick={async () => {
                        await deleteDog(selectedReq.id);
                    }}/></div>
                    <div className='col-sm-6 col-md-6 col-lg-3'><Button className="mt-4 block" icon="email" disabled={!isDraft || draftDirty} type={'default'} text="Отправить заявку" hint="Отправить заявку" onClick={() => onSendRequest(true)}/></div>
                </div>
                <ErrorPopup text={popupErrorText}
                            icon = {popupIcon}
                            width={popupWidth}
                            title ={popupTitle}
                            btnVisible={true}
                            visible={popupErrorVisible}
                            onOk={onOk}
                            classNameColorIcon={popupClassNameColorIcon}
                            btnVisibleCancel={btnVisibleCancel}
                            onCancel={onCancel}
                            onCancelWithOk={onCancelWithOk ?? onCancel}
                            textOk={popupTextOk ?? (popupYesNo ? 'Да' : undefined)}
                            textCancel={popupTextCancel ?? (popupYesNo ? 'Нет' : undefined)}
                />
                <Popup
                    visible={popupFindInnVisible}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    onHiding={hidePop}
                    maxWidth={450}
                    maxHeight={'90%'}
                    height={'auto'}
                    titleRender={()=>PopupTitleWithIcon('dx-icon-fieldchooser', "Заполнить поля",hidePop)}
                >
                    <ScrollView width='100%' height='100%'>
                        <div className="row justify-content-around">
                            <div className="col-sm-12">
                                <p>Для ИНН:{selectedReq.inn} найдены поля:</p>
                                {nameCompany &&
                                    <>
                                        <p>Наименование абонента:<br/>
                                            {nameCompany}</p>
                                    </>
                                }
                                {kpp &&
                                    <>
                                        {kppList.length > 1 && <>Выберите</>} KПП:
                                        <RadioGroup
                                            id="radio-group-with-selection"
                                            items={kppList}
                                            defaultValue={kppList[0]}
                                            onValueChanged={changeKPP}
                                        />
                                    </>
                                }
                                <Button className={'float-right ml-2'} text='Отмена' onClick={() => {
                                    hidePop()
                                }} />
                                <Button className={'float-right'} text='Заполнить' onClick={async () => {
                                    await saveOneFieldOnBlurFocus('name_company',nameCompany)
                                    await saveOneFieldOnBlurFocus('kpp',kpp)
                                    await getListZayavka()
                                    hidePop()
                                }} />
                            </div>
                        </div>
                    </ScrollView>
                </Popup>
                <Popup
                    visible={popupRefusedVisible}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    title="Отказ от подписи"
                    maxWidth={600}
                    maxHeight={'90%'}
                    height={'auto'}
                    onHiding={hidePopRefused}
                    titleRender={()=>PopupTitleWithIcon(faKey, "Отказ от подписи",hidePopRefused)}
                >
                    <ScrollView width='100%' height='100%'>
                        <form onSubmit={onFormSubmitRefused} tabIndex={0} onKeyDown={(e) => {
                            if (e.key === 'Escape') hidePopRefused();
                        }}>
                            <TextBox
                                showClearButton={true}
                                value={refusedMessage}
                                labelMode='floating'
                                label={'Причина отказа'}
                                onValueChanged={(e) => setRefusedMessage(e.value)}>
                                <ValidatorDevex>
                                    {popupRefusedVisible && <RequiredRuleValidator message={'Обязательное поле'}/>}
                                </ValidatorDevex>

                            </TextBox>
                            <Button useSubmitBehavior={true} className={'float-right mt-4'} text='Отправить'/>
                        </form>
                    </ScrollView>
                </Popup>
            </>

            {(selectedReq.id_status !== undefined && selectedReq.id_status !== 10) &&
                <>
                    <div className="row round-button-only-icon mb-5">

                        <div className='col-12 font-weight-bold mb-2'>Документы к подписанию:</div>
                        {finalDog?.length === 0 &&
                            <div className={'col-12'}><i> Пока нет прикрепленного договора</i></div>
                        }
                        {finalDog?.length > 0 &&
                            finalDog.map((finalDog, i) =>
                                finalDog &&
                                <div key={finalDog.id + '' + i} className='hideOvarlayLayer col-12 mt-1'>
                                    <div className={'d-flex flex-row align-items-center'}>
                                        <div>
                                            <Button type='default' className='mr-1'
                                                    hint='Скачать всё архивом' icon={'download'}
                                                    onClick={async () => {
                                                        await downloadZip(finalDog.id);
                                                    }}></Button>
                                        </div>
                                        {finalDog?.client_sign_refused ?
                                            <span title='Отказались от подписи' className='p-2 danger'><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0.58681 16.5962L1.96378 18L10.982 8.80608C11.6929 9.23774 12.505 9.47589 13.3573 9.47589C14.5983 9.47589 15.7662 8.9847 16.6422 8.08698C18.4526 6.24129 18.4526 3.2346 16.6422 1.38891C15.7662 0.495838 14.5982 2.01491e-06 13.3573 1.90642e-06C12.1164 1.79794e-06 10.9484 0.491193 10.0724 1.38891C8.45629 3.03646 8.28658 5.61137 9.55679 7.45706L6.07728 11.0044L4.56891 9.4666L3.19194 10.8704L4.70031 12.4082L2.88534 14.2585L1.37697 12.7207L-9.26741e-07 14.1245L1.50837 15.6623L0.588561 16.6L0.58681 16.5962ZM11.4447 2.79259C11.9557 2.27163 12.6318 1.98882 13.3527 1.98882C14.0727 1.98882 14.7543 2.27627 15.2608 2.79259C16.312 3.86428 16.312 5.61042 15.2608 6.68759C14.7498 7.20855 14.0736 7.49136 13.3527 7.49136C12.6328 7.49136 11.9511 7.20391 11.4446 6.68759C10.3934 5.6159 10.3934 3.86976 11.4447 2.79259Z"/>
                                                        </svg></span>
                                            :
                                            <>
                                                <div className={'mr-1'}><PopSelectCert companyKeyName={finalDog.companyKeyName}
                                                                                       companyKey={finalDog.companyKey}
                                                                                       idFile={finalDog.id}
                                                                                       clientKey={!!finalDog.clientKeyName}
                                                                                       onSuccessSign={onSuccessSign}/>
                                                </div>

                                                <div>
                                                    <Button type='danger' className='mr-1' visible={!finalDog.clientKeyName}
                                                            hint='Отказаться от подписи документа' icon={'images/flash.svg'}
                                                            onClick={async () => {
                                                                setFinalDogId(finalDog.id)
                                                                setRefusedMessage('')
                                                                setPopupRefusedVisible(true)
                                                            }}></Button>
                                                </div>
                                            </>
                                        }
                                        <div className='ml-2'>
                                            {/*<strong>{finalDog.filename}</strong>*/}{/*<br/>
                                                        <i>Подписан сбытовой компанией: <b>{finalDog.companyKeyName ? 'Да' : 'Нет'}</b><span> <FontAwesomeIcon
                                                            icon={faKey}
                                                            color={finalDog.companyKeyName ? 'green' : 'red'}/></span>; </i>
                                                        <i>Подписан клиентом: <b>{finalDog.clientKeyName ? 'Да' : 'Нет'}</b></i>
                                                        <span><FontAwesomeIcon
                                                                icon={faKey}
                                                                color={finalDog.clientKeyName ? 'green' : 'red'}/></span>*/}
                                            <a title={`Открыть "${finalDog.filename}" в браузере в новом окне`} className="dashed" id="link1" href='/' onClick={async (e) => {e.preventDefault(); await downloadAsFile(finalDog.id, finalDog.filename); }}>{finalDog.filename}</a>
                                        </div>

                                    </div>
                                </div>

                            )
                        }
                        {finalDog?.length > 1 &&
                            <div className='col-12 mt-3'>
                                {/*<Button className='' hint='Отказ от подписи всех документов' type='default' icon='images/key-remove.svg' onClick={ async (e) => notify("Отказались от подписи всех документов", 'success', 5000)}></Button>*/}
                                <Button className='' text={'Скачать все документы'} hint='Скачать все документы' type='default' icon='export'
                                        onClick={async () => {
                                            await downloadZipAll(selectedReq.id);
                                        }}></Button>
                            </div>
                        }
                    </div>
                    <div className="mt20">
                        <label><b>Переписка по заявке:</b><LoadIndicator width={'24px'} height={'24px'} visible={loadingMessage}/></label>
                        <div style={{height: '350px',border: '1px solid lightgray',overflowY: 'auto', padding: '10px'}}>
                            {
                                messages.map((message, i) => {
                                    return <div key={i}>
                                        <label><b>[{formatTimestamp(new Date(message.date_create))}] {message.type_message === 0 ? (user.firstName ? user.firstName+' '+user.lastName:user.lastName) : message.username}:</b></label>
                                        <p>{message.text_message}</p>
                                        {message.attachments?.map((attach) => <span key={attach.id}>
                                            <a href="/" id={attach.id} onClick={async (e) => {
                                                e.preventDefault();
                                                await downloadAkt(attach.id, false)
                                            }}>{attach.filename}</a>; </span>)}
                                    </div>

                                })
                            }
                        </div>
                        <div>
                            <form onSubmit={onSendMessage}>
                                <Form ref={formMessageRef} colCount={2} labelMode={'floating'} formData={messageFormData.current} >
                                    <Item dataField="message" editorType='dxTextArea' editorOptions={{autoResizeEnabled: true}}>
                                        <Label text={"Новое сообщение"}/>
                                    </Item>
                                    {process.env.REACT_APP_NAME_ENV !== "tatenergosbyt" &&
                                        <GroupItem>
                                    <Item>
                                        <ExtFileUploader  selectedReqId={selectedReq.id ?? null} ref={extFileUploaderPerepiskaRef} setfile={(e) => messageFormData.current.attachments = e }></ExtFileUploader>
                                    </Item>

                                        </GroupItem>
                                    }
                                    {process.env.REACT_APP_NAME_ENV !== "tatenergosbyt" &&<EmptyItem/>}
                                    <ButtonItem
                                        horizontalAlignment="right" cssClass='mt-2'
                                    >
                                        <ButtonOptions
                                            type={'default'}
                                            useSubmitBehavior={true}
                                            text="Отправить"
                                            icon="email"
                                        />
                                    </ButtonItem>
                                </Form>
                            </form>
                        </div>
                    </div>
                </>
            }
        </div>
    )

}

export default AddDogovorTatenergosbytPage


